const ENV = process.env.VUE_APP_ENV

export const APPID = 80001
export const referRalAppid = 10034
export const APPKEY = process.env.VUE_APP_ENV === 'production' ? 'Bbse6ANgsDw' : 'uFixu5GBotU'
// channelid和activitycode 基于 http://wiki.vipkid.com.cn/pages/viewpage.action?pageId=170008347
export const ACTIVITYCODE = ENV === 'production' ? '2a6b6c7a3610dea0' : '1873a332591b6ff2'
export const CHANNELID = ENV === 'production' ? '14767881' : '1476761125'
export const TEMPLATEID = ENV === 'production' ? '3Cx1UCoa-XA' : 'gFt0dO5fqpg'
export const REQUESTURL = location.host + location.pathname // `stage-math-customer.vipkid-qa.com.cn/math-customer/index.html`

export default {
  env: ENV,
  appid: APPID,
  appKey: APPKEY,
  activityCode: ACTIVITYCODE,
  channelId: CHANNELID,
  templateId: TEMPLATEID,
  requestUrl: REQUESTURL

}
